var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access.status === 'invited')?_c('IconBtn',{attrs:{"loading":_vm.loading,"title":"Invite","icon":"mdi-send","small":false,"xSmall":true},on:{"click":function($event){$event.stopPropagation();return _vm.invite.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }